import { Component, HostListener } from '@angular/core';
import { trigger, state, style, animate, transition } from '@angular/animations';

@Component({
  selector: 'reactive-text',
  templateUrl: './reactive-text.component.html',
  styleUrls: ['./reactive-text.component.css'],
  animations: [
    trigger('fadeText', [
      state('show', style({ opacity: 1 })),
      state('hide', style({ opacity: 0 })),
      transition('show <=> hide', [animate('0.6s ease-in-out')]),
    ])
  ]
})
export class ReactiveTextComponent {
  currentIndex = 0;
  textClass = 'show';

  ngOnInit() {
    setInterval(() => {
      this.textClass = 'hide';
      setTimeout(() => {
        this.currentIndex = (this.currentIndex + 1) % 3;
        this.textClass = 'show';
      }, 600);
    }, 5000);
  }

  icons = {
    sphere3: 'assets/images/sphere-3.png'
  };

  @HostListener('window:scroll', [])
    onWindowScroll() {
      const scrollY = window.scrollY;

      const sphere5 = document.querySelector('.hero-sphere-5') as HTMLElement;
      if (sphere5) sphere5.style.transform = `translateY(${scrollY * 0.1}px)`;

    }
}
